/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

const Fill = ({ color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="none" viewBox="0 0 26 26">
        <path
            fill={color}
            fillRule="evenodd"
            stroke={color === 'rgb(255, 255, 255)' ? '#757575' : '#fff'}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.25"
            d="M24.314 25H1.686A.686.686 0 0 1 1 24.314V1.686C1 1.307 1.307 1 1.686 1h22.628c.38 0 .686.307.686.686v22.628a.686.686 0 0 1-.686.686Z"
            clipRule="evenodd"
        />
        <path
            fill="#fff"
            fillRule="evenodd"
            stroke={color === 'rgb(255, 255, 255)' ? '#757575' : color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.25"
            d="M17.698 17.982H8.302a.285.285 0 0 1-.284-.284V8.302c0-.157.127-.284.284-.284h9.396c.157 0 .284.127.284.284v9.396a.285.285 0 0 1-.284.284Z"
            clipRule="evenodd"
        />
    </svg>
);

Fill.propTypes = {
    color: PropTypes.string.isRequired,
};

export default Fill;
